import { MenuList, Stack } from "@mui/material";
import useIsMobile from "hooks/react-lib/generic-ui/useIsMobile";
import React from "react";
import View from "views//View";
import FriendsList from "components/talk/FriendsList";
import ManageFriendsButton from "components/talk/ManageFriendsButton";
import ManageFriendsModal from "components/talk/ManageFriendsModal";
import ActiveTalk from "components/talk/ActiveTalk";
import { useParams } from "react-router-dom";
import NoActiveTalk from "components/talk/NoActiveTalk";
import TalkDrawerMenu from "components/talk/TalkDrawerMenu";
import CurrentBotHeader from "components/bot/CurrentBotHeader";

export default function TalkView() {

  const isMobile = useIsMobile();
  const CONVERSATION_LIST_WIDTH = 300;

  const params = useParams();
  const friendId = params.friendId;

  return (
    <View
      renderLeftActions={() => {
        return <CurrentBotHeader />;
      }}
      renderRightActions={() => {
        return <TalkDrawerMenu />;
      }}
    >
      <ManageFriendsModal />
      {!isMobile && ( // Only render conversations on desktop
        <Stack p={1}>
          <Stack px={2} pb={1}>
            <ManageFriendsButton />
          </Stack>
          <MenuList
            sx={{
              height: "95%", // A bit hacky, we should fix this
              width: `${CONVERSATION_LIST_WIDTH}px`,
              overflowY: "auto",
              overflowX: "none",
              boxSizing: "border-box",
            }}
          >
            <FriendsList />
          </MenuList>
        </Stack>
      )}
      <Stack
        sx={{
          width: `calc(100% - ${isMobile ? 0 : CONVERSATION_LIST_WIDTH}px)`,
          height: "100%",
          overflow: "hidden",
        }}
      >
        {friendId ? <ActiveTalk /> : <NoActiveTalk />}
      </Stack>
    </View>
  );
}
